module.exports = __webpack_public_path__ + "static/media/S (192).946f28dd.jpg";